import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { cancelCheckout } from '../../Redux/ActionCreators/settingAction';

export default function BillingCancel() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [status, setStatus] = useState('loading');
    const calledRef = useRef(false);

    useEffect(() => {
        if (calledRef.current) return;
        calledRef.current = true;

        const orderId = localStorage.getItem('payment_order_id');
        if (orderId) {
            Promise.resolve(dispatch(cancelCheckout(orderId)))
                .finally(() => {
                    localStorage.removeItem('payment_order_id');
                    setStatus('cancelled');
                    setTimeout(() => { navigate('/plan'); }, 3000);
                });
        } else {
            setStatus('cancelled');
            setTimeout(() => { navigate('/plan'); }, 3000);
        }
    }, [dispatch, navigate]);

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#f8f9fa', fontFamily: '"Inter", "Segoe UI", Roboto, sans-serif' }}>
            <style>
                {`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
                `}
            </style>
            <div style={{ backgroundColor: '#ffffff', padding: '40px 32px', borderRadius: '16px', boxShadow: '0 10px 25px rgba(0,0,0,0.05)', textAlign: 'center', maxWidth: '400px', width: '90%' }}>
                {status === 'loading' && (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px' }}>
                        <div style={{ width: '60px', height: '60px', border: '6px solid rgba(247, 88, 145, 0.2)', borderTop: '6px solid #F75891', borderRadius: '50%', animation: 'spin 1s linear infinite', marginBottom: '12px' }}></div>
                        <h2 style={{ margin: '0', fontSize: '24px', color: '#2d3436', fontWeight: '600' }}>Cancelling Payment</h2>
                        <p style={{ margin: '0', color: '#636e72', fontSize: '15px', lineHeight: '1.5' }}>Please wait while we process your cancellation...</p>
                    </div>
                )}

                {status === 'cancelled' && (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px' }}>
                        <i className="fas fa-times-circle" style={{ fontSize: '64px', marginBottom: '8px', color: '#e74c3c' }} />
                        <h2 style={{ margin: '0', fontSize: '24px', color: '#2d3436', fontWeight: '600' }}>Payment Cancelled</h2>
                        <p style={{ margin: '0', color: '#636e72', fontSize: '15px', lineHeight: '1.5' }}>Your transaction was cancelled and you haven't been charged. Taking you back...</p>
                    </div>
                )}
            </div>
        </div>
    );
}
